import React, { PropsWithChildren } from "react";
import { useEditor, useNode, UserComponent } from "@craftjs/core";
import ContentEditable from "react-contenteditable";
import { css } from "@emotion/react";
import {
  IBuilderBlockProps,
  BuilderBlock,
} from "../../shared/BuilderBock/BuilderBlock";
import { TextSettings } from "./TextSettings";
import { StyleSettings } from "../../../editor/stylePanel";
import { defaultCssStyles, defaultStyleProps } from "../../shared";

export interface ITextProps extends IBuilderBlockProps {
  fontSize: string;
  textAlign: string;
  fontWeight: string;
  shadow: number;
  text: string;
}

export const Text: UserComponent<Partial<ITextProps>> = ({
  fontSize,
  fontWeight,
  textAlign,
  color,
  shadow,
  text,
  // margin = ["0px", "0px", "0px", "0px"],
  // padding = ["0px", "0px", "0px", "0px"],
  ...rest
}) => {
  const {
    connectors: { connect },
    setProp,
  } = useNode();

  const { enabled } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));

  return (
    <BuilderBlock {...rest}>
      <ContentEditable
        innerRef={connect}
        html={text ?? ""}
        disabled={!enabled}
        css={[
          defaultCssStyles(rest),
          css`
            color: ${color ? `rgba(${Object.values(color)})` : null};
            font-size: ${fontSize}px;
            text-shadow: 0px 0px 2px rgba(0, 0, 0, ${(shadow || 0) / 100});
            font-weight: ${fontWeight};
            text-align: ${textAlign};
          `,
        ]}
        onChange={(e) => {
          setProp((prop) => (prop.text = e.target.value), 500);
        }}
      />
    </BuilderBlock>
  );
};

Text.craft = {
  displayName: "Text",
  props: {},
  related: {
    toolbar: TextSettings,
    styles: StyleSettings,
  },
};

Text.defaultProps = { ...defaultStyleProps };
